module.exports = __webpack_public_path__ + "img/fanzhuan02.71815c22.png";